module.exports = __webpack_public_path__ + "static/media/trophy-8.1f754bba.svg";